import React, { useState, useEffect } from "react";
import "../Mission.css";
import { useEtatGlobal } from "../../EtatGlobal.js";
import { useClients } from "../../Portefeuille/useClients.js";

import { authFetch, httpClient } from "../../../HttpClient";

import { dialog } from "../../../components/ui/Dialog";
import { showSuccessToast, showStatusToast } from "../../../components/ui/Toast";
import { uploadFileToBlob } from "../../../utils/uploadFileToBlob";
import { normalizeText } from "../../../utils/text.js";
import {
  Building2,
  AlertCircle,
  UserCheck,
  MapPin,
  Trash2,
  Users,
  FileText,
  ChevronUp,
  ChevronDown,
  Loader2,
  Check,
} from "lucide-react";

const secteursRef = [
  {
    secteurActivite: "Restauration sans alcool",
    secteurActiviteCommentaire: "- Permis d’exploitation",
  },
  {
    secteurActivite: "Restauration avec alcool",
    secteurActiviteCommentaire:
      "- Permis d’exploitation - Récépissé débit boisson",
  },
  {
    secteurActivite: "Bâtiment, travaux publics",
    secteurActiviteCommentaire:
      "- Diplôme ou expérience > 3 ans pour chaque lot déclaré",
  },
  {
    secteurActivite: "Médical et paramédical",
    secteurActiviteCommentaire:
      "- Diplôme - Numéro RPPS - Inscription à l’ordre",
  },
  {
    secteurActivite: "Transport",
    secteurActiviteCommentaire:
      "- Diplôme - Numéro RPPS - Inscription à l’ordre",
  },
  {
    secteurActivite: "Agent immobilier",
    secteurActiviteCommentaire: "- Mandat d’agent commercial",
  },
  {
    secteurActivite: "Coiffure, esthétique",
    secteurActiviteCommentaire: "- Diplôme ou expérience > 3 ans",
  },
];

const CreationSct = ({ onCancel }) => {
  const { setJuridiquePonctuelleData, fetchJuridiquePonctuelle, annuaireData } =
    useEtatGlobal();
  const { data: clients = [] } = useClients();
  const [leadError, setLeadError] = useState("");
  const [formData, setFormData] = useState({
    formLeadId: "",
    clientId: "",
    annuaireId: "",
    envelopeId: "",
    formeSociale: "",
    nomSociete: "",
    siegeSocial: "",
    typeSocial: "",
    capital: "",
    banque: "",
    clauseAgreement: false,
    clauseExclusion: false,
    clauseInalienabilite: false,
    clausePreemption: false,
    clauseSortie: false,
    autresClauses: false,
    commentaire: "",
    existenceAction: false,
    quorum: false,
    limitation: false,
    autresClauses2: false,
    commentaire2: "",
    secteurActivite: "",
    secteurActiviteCommentaire: "",
    activite: "",
    //
    regimeFiscal: "",
    regimeTVA: "",
    dateCloture: "",
    acteAnterieur: false,
    commentaire3: "",
    dueDate: "",
    priority: "classique",
    status: "En attente",
    coefficient: "",
    //
    emailLead: "",
    nomCommercial: "",
    adresse_complement: "",
    codePostal: "",
    ville: "",
  });

  const [documents, setDocuments] = useState({
    pieceId: null,
    livretFamille: null,
    carteSecurite: null,
    avisImposition: null,
    adressse: null,
    dernierAvisImposition: null,
    pieceIdHebergeur: null,
  });

  const [clausesAssociesOpen, setClausesAssociesOpen] = useState(false);
  const [clausesAssociesOpen2, setClausesAssociesOpen2] = useState(false);
  const [ChaqueAssocieDocument, setChaqueAssocieDocument] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [envoyerMail, setEnvoyerMail] = useState(true);

  // Collaborateurs à notifier
  const [allUsers, setAllUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [notifiedUserIds, setNotifiedUserIds] = useState([]);

  useEffect(() => {
    httpClient
      .get("https://backend-myalfa.vercel.app/api/users")
      .then(({ data }) => setAllUsers(data))
      .catch(() => {});
  }, []);

  const handleSearchUser = (e) => {
    const q = e.target.value;
    setSearchUser(q);
    if (q.length < 1) {
      setUserSuggestions([]);
      return;
    }
    setUserSuggestions(
      allUsers
        .filter(
          (u) =>
            normalizeText(`${u.name} ${u.lastName}`).includes(normalizeText(q)) &&
            !notifiedUserIds.includes(u.id)
        )
        .slice(0, 8)
    );
  };

  const selectUser = (user) => {
    setNotifiedUserIds((prev) => [...prev, user.id]);
    setSearchUser("");
    setUserSuggestions([]);
  };

  const removeUser = (id) =>
    setNotifiedUserIds((prev) => prev.filter((i) => i !== id));

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setDocuments((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const [associes, setAssocies] = useState([
    { nomAssocie: "", pourcentage: 0, dirigeant: false },
  ]);

  const [selectedSecteur, setSelectedSecteur] = useState("");

  const addSecteur = () => {
    const found = secteursRef.find(
      (s) => s.secteurActivite === selectedSecteur
    );
    if (!found) return;

    setFormData((prev) => ({
      secteurActivite: prev.secteurActivite
        ? prev.secteurActivite + " / " + found.secteurActivite
        : found.secteurActivite,
      secteurActiviteCommentaire: prev.secteurActiviteCommentaire
        ? prev.secteurActiviteCommentaire +
          " / " +
          found.secteurActiviteCommentaire
        : found.secteurActiviteCommentaire,
    }));

    setSelectedSecteur(""); // reset select
  };

  // Supprimer un secteur
  const removeSecteur = (secteur) => {
    const activites = formData.secteurActivite.split(" / ");
    const commentaires = formData.secteurActiviteCommentaire.split(" / ");

    // retrouver l'index dans la liste
    const index = activites.findIndex((a) => a === secteur);
    if (index === -1) return;

    activites.splice(index, 1);
    commentaires.splice(index, 1);

    setFormData({
      secteurActivite: activites.join(" / "),
      secteurActiviteCommentaire: commentaires.join(" / "),
    });
  };

  const [formLeads, setFormLeads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        // Fetch formLeads
        const resFormLeads = await authFetch(
          "https://backend-myalfa.vercel.app/api/formleads"
        );
        const dataFormLeads = await resFormLeads.json();
        const formLeadsData =
          resFormLeads.ok && dataFormLeads.data ? dataFormLeads.data : [];

        // Fetch all-documents
        const resDocs = await authFetch(
          "https://backend-myalfa.vercel.app/api/all-documents"
        );
        const dataDocs = await resDocs.json();
        const docsLeads = Array.isArray(dataDocs)
          ? dataDocs.map((doc) => ({
              envelopeId: doc.id,
              nom: doc.societeNom || "", // <-- Utilisation de societeNom
              prenom: "", // Pas dispo dans all-documents
              mail: doc.email || "", // email non-null selon ton API
              source: "documents",
            }))
          : [];

        // Combinaison des deux sources
        setFormLeads([...formLeadsData, ...docsLeads]);
      } catch (error) {
        console.error("Erreur lors du chargement des leads", error);
      }
    };

    fetchLeads();
  }, []);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const search = searchTerm.toLowerCase();
      // Match si le texte complet contient le terme OU si au moins un mot le contient
      const matches = (text) => {
        const normalized = (text || "").trim().toLowerCase();
        return (
          normalized.includes(search) ||
          normalized.split(" ").some((word) => word.includes(search))
        );
      };

      const filteredClients = clients
        .filter((c) => matches(c.nom))
        .slice(0, 25)
        .map((c) => ({ ...c, type: "client" }));

      const filteredLeadsResult = formLeads.filter((lead) =>
        matches(`${lead.prenom} ${lead.nom}`)
      ).map((lead) => ({ ...lead, type: "prospect" }));

      const filteredAnnuaire = annuaireData
        .filter((a) => matches(`${a.nom} ${a.prenoms}`))
        .slice(0, 25)
        .map((a) => ({ ...a, type: "annuaire" }));

      setFilteredSuggestions([
        ...filteredClients,
        ...filteredLeadsResult,
        ...filteredAnnuaire,
      ]);
      setShowSuggestions(true);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  }, [searchTerm, formLeads, clients, annuaireData]);

  // Libellé affiché pour la source actuellement sélectionnée (client, lead ou
  // annuaire) — sert à détecter quand l'utilisateur modifie le texte après
  // sélection, pour réinitialiser le bon champ (un seul actif à la fois).
  const getSelectedItemLabel = () => {
    if (formData.clientId) {
      const c = clients.find((c) => c.id === formData.clientId);
      return c?.nom || "";
    }
    if (formData.annuaireId) {
      const a = annuaireData.find((a) => a.id === formData.annuaireId);
      return `${a?.nom || ""} ${a?.prenoms || ""}`.trim();
    }
    if (formData.formLeadId) {
      const l = formLeads.find((l) => l.id === formData.formLeadId);
      return `${l?.prenom ? l.prenom + " " : ""}${l?.nom || ""}`.trim();
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAssocieChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updated = [...associes];
    updated[index][name] = type === "checkbox" ? checked : value;
    setAssocies(updated);
  };

  const addAssocie = () => {
    setAssocies([
      ...associes,
      {
        nomAssocie: "",
        emailAssocie: "",
        telephoneAssocie: "",
        pourcentage: 0,
        dirigeant: false,
      },
    ]);
  };

  const removeAssocie = (index) => {
    const updated = [...associes];
    updated.splice(index, 1);
    setAssocies(updated);
  };

  const handleSelectItem = (item) => {
    if (!item || !item.id) {
      console.error("Élément invalide :", item);
      return;
    }

    if (item.type === "client") {
      setFormData((prev) => ({
        ...prev,
        clientId: item.id,
        formLeadId: null,
        annuaireId: null,
        emailLead: item.email || "",
      }));
      setSearchTerm(item.nom || "");
    } else if (item.type === "annuaire") {
      setFormData((prev) => ({
        ...prev,
        annuaireId: item.id,
        formLeadId: null,
        clientId: null,
        emailLead: item.email || "",
      }));
      setSearchTerm(`${item.nom || ""} ${item.prenoms || ""}`.trim());
    } else {
      // type "prospect" (lead)
      setFormData((prev) => ({
        ...prev,
        formLeadId: item.id,
        clientId: null,
        annuaireId: null,
        emailLead: item.mail || "",
      }));
      setSearchTerm(`${item.prenom ? item.prenom + " " : ""}${item.nom}`);
    }

    setShowSuggestions(false);
    setLeadError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    // UI instantanée : la mission apparaît tout de suite dans le tableau
    // Suivi Juridique Ponctuel, l'overlay se ferme, les appels partent en fond
    const tempId = `temp-${Date.now()}`;
    const selectedLead =
      formLeads.find((l) => l.id === parseInt(formData.formLeadId)) || null;
    const selectedClient =
      clients.find((c) => c.id === parseInt(formData.clientId)) || null;
    const selectedAnnuaire =
      annuaireData.find((a) => a.id === parseInt(formData.annuaireId)) ||
      null;
    const optimisticItem = {
      id: tempId,
      source: "creationsct",
      missionLabel: "Immatriculation",
      descriptif: [formData.formeSociale, formData.regimeFiscal]
        .filter(Boolean)
        .join(" / "),
      nomSociete: formData.nomSociete,
      nomCommercial: formData.nomCommercial,
      formeSociale: formData.formeSociale,
      regimeFiscal: formData.regimeFiscal,
      regimeTVA: formData.regimeTVA,
      formLeadId: formData.formLeadId ? Number(formData.formLeadId) : null,
      formLead: selectedLead,
      clientId: formData.clientId ? Number(formData.clientId) : null,
      client: selectedClient,
      annuaireId: formData.annuaireId ? Number(formData.annuaireId) : null,
      annuaire: selectedAnnuaire,
      dueDate: formData.dueDate
        ? new Date(formData.dueDate).toISOString()
        : null,
      priority: formData.priority || "classique",
      status: formData.status || "En attente",
      coefficient: formData.coefficient || null,
      createdAt: new Date().toISOString(),
      associes: [],
      Commentaire: [],
      Historique: [],
    };
    setJuridiquePonctuelleData((prev) => [...prev, optimisticItem]);
    onCancel?.();
    showSuccessToast(
      "Mission Immatriculation créée",
      "Vous la retrouverez dans le tableau Suivi Juridique Ponctuel."
    );

    try {
      // 🧩 1️⃣ Création du FormData pour envoyer textes + fichiers
      const formToSend = new FormData();

      formToSend.append("formLeadId", Number(formData.formLeadId));
      formToSend.append("clientId", Number(formData.clientId));
      formToSend.append("annuaireId", Number(formData.annuaireId));
      formToSend.append("envelopeId", Number(formData.envelopeId));
      formToSend.append("formeSociale", formData.formeSociale || "");
      formToSend.append("nomSociete", formData.nomSociete || "");
      formToSend.append("siegeSocial", formData.siegeSocial || "");
      formToSend.append("typeSocial", formData.typeSocial || "");
      formToSend.append("capital", formData.capital || "");
      formToSend.append("banque", formData.banque || "");
      formToSend.append("secteurActivite", formData.secteurActivite || "");
      formToSend.append("activite", formData.activite || "");
      formToSend.append("regimeFiscal", formData.regimeFiscal || "");
      formToSend.append("regimeTVA", formData.regimeTVA || "");
      formToSend.append("dateCloture", formData.dateCloture || "");
      formToSend.append("dueDate", formData.dueDate || "");
      formToSend.append("commentaire", formData.commentaire || "");
      formToSend.append("commentaire2", formData.commentaire2 || "");
      formToSend.append("commentaire3", formData.commentaire3 || "");
      formToSend.append("priority", formData.priority || "classique");
      formToSend.append("status", formData.status || "En attente");
      formToSend.append("coefficient", formData.coefficient || "");
      formToSend.append("nomCommercial", formData.nomCommercial || "");
      formToSend.append(
        "adresse_complement",
        formData.adresse_complement || ""
      );
      formToSend.append("codePostal", formData.codePostal || "");
      formToSend.append("ville", formData.ville || "");
      formToSend.append("envoyerMail", envoyerMail ? "true" : "false");

      // ✅ Ajouter les booléens (clauses, etc.)
      [
        "clauseAgreement",
        "clauseExclusion",
        "clauseInalienabilite",
        "clausePreemption",
        "clauseSortie",
        "autresClauses",
        "existenceAction",
        "quorum",
        "limitation",
        "autresClauses2",
        "acteAnterieur",
      ].forEach((key) => {
        formToSend.append(key, formData[key] ? "true" : "false");
      });

      // ✅ Ajouter les associés sous forme JSON
      formToSend.append(
        "associes",
        JSON.stringify(
          associes.map((a) => ({
            ...a,
            pourcentage: parseFloat(a.pourcentage),
          }))
        )
      );

      // ✅ Ajouter les fichiers (documents) — upload direct navigateur → Blob
      // (contourne la limite 4,5 Mo), un toast informe de la progression.
      const fileEntries = Object.entries(documents).filter(([, file]) => file);
      if (fileEntries.length > 0) {
        const uploadToast = showStatusToast({ status: "loading", titre: "Envoi du document...", message: "0 %" });
        for (const [key, file] of fileEntries) {
          const url = await uploadFileToBlob(
            file,
            "https://backend-myalfa.vercel.app/api/creation-sct/upload-token",
            ({ percentage }) =>
              uploadToast.update({ status: "loading", titre: "Envoi du document...", message: `${Math.round(percentage)} %` })
          );
          formToSend.append(`${key}Url`, url);
        }
        uploadToast.update({ status: "success", titre: "Document envoyé", message: "" });
      }

      // 📨 2️⃣ Envoi vers l’API `creation-sct`
      const res = await authFetch(
        "https://backend-myalfa.vercel.app/api/creation-sct",
        {
          method: "POST",
          body: formToSend, // ⚠️ pas de Content-Type ici (fetch le gère)
        }
      );

      const result = await res.json();
      if (!res.ok) {
        throw new Error(result?.message || "Erreur lors de la création.");
      }

      // ✅ Récupération de l'id créé
      const creationSctId = result.idSct;

      // ✅ Stockage dans une variable + affichage
      console.log("ID du CreationSct créé :", creationSctId);

      // Remplace l'élément provisoire par l'enregistrement réel
      if (creationSctId) {
        setJuridiquePonctuelleData((prev) =>
          prev.map((item) =>
            item.id === tempId && item.source === "creationsct"
              ? { ...optimisticItem, id: creationSctId }
              : item
          )
        );
      }

      // 3️⃣ Envoi de l’email (données simples sans fichiers)
      const lead = formLeads.find(
        (l) => l.id === parseInt(formData.formLeadId)
      );

      const enveloppe = formLeads.find(
        (l) => l.envelopeId === parseInt(formData.envelopeId)
      );

      if (envoyerMail && formData.emailLead && creationSctId) {
        const emailImmPayload = {
          id: creationSctId,
          email: formData.emailLead,
        };

        const emailImmRes = await authFetch(
          "https://backend-myalfa.vercel.app/api/email-imm-client",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(emailImmPayload),
          }
        );

        if (!emailImmRes.ok) {
          console.warn("⚠️ L'email IMM client n'a pas été envoyé.");
        }
      }

      const userEmails = allUsers
        .filter((u) => notifiedUserIds.includes(u.id))
        .map((u) => u.email)
        .filter(Boolean);

      const emailPayload = {
        ...formData,
        dateCloture: formData.dateCloture
          ? new Date(formData.dateCloture).toISOString().split("T")[0]
          : null,
        dueDate: formData.dueDate
          ? new Date(formData.dueDate).toISOString().split("T")[0]
          : null,
        nomClient: lead
          ? `${lead.prenom} ${lead.nom}`
          : enveloppe
          ? enveloppe.nom
          : formData.nomSociete,
        associes: associes.map((a) => ({
          ...a,
          pourcentage: parseFloat(a.pourcentage),
        })),
        userEmails,
      };

      const emailRes = await authFetch(
        "https://backend-myalfa.vercel.app/api/email-creation-societe",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(emailPayload),
        }
      );

      if (!emailRes.ok) {
        console.warn("L'email de création de société n'a pas été envoyé.");
      }

      // Resynchronise uniquement le Suivi Juridique Ponctuel (plus léger que fetchAll)
      fetchJuridiquePonctuelle();
    } catch (err) {
      console.error("Erreur exacte :", err);
      // Échec : on retire la mission provisoire du tableau
      setJuridiquePonctuelleData((prev) =>
        prev.filter(
          (item) => !(item.id === tempId && item.source === "creationsct")
        )
      );
      dialog.alert("Erreur lors de la création : " + err.message);
    } finally {
      setIsSubmitting(false);
      setNotifiedUserIds([]);
      setSearchUser("");
    }
  };

  console.log("Form Data:", formData);

  return (
    <div className="flex flex-col h-full">
      <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
        <div className="flex-1 min-h-0 overflow-y-auto px-6 py-4">
        <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Immatriculation
        </h3>
      </div>
        <br />
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>

          <div className="space-y-4">
            {/* Label */}
            <div>
              <label className="text-sm font-semibold flex items-center gap-2 text-slate-700">
                <UserCheck className="w-4 h-4 text-slate-500" />
                Client/Lead/Annuaire <span className="text-red-500">*</span>
              </label>

              {/* Input style "Button outline" */}
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchTerm(value);

                  // Si l'utilisateur change le texte et qu'il diffère de la
                  // source sélectionnée (client/lead/annuaire), on réinitialise
                  const expected = getSelectedItemLabel();
                  if (expected && value !== expected) {
                    setFormData((prev) => ({
                      ...prev,
                      formLeadId: null,
                      clientId: null,
                      annuaireId: null,
                    }));
                    setLeadError(
                      "Veuillez sélectionner un client, un lead ou un contact de l'annuaire existant. Si l'élément n'existe pas, veuillez le créer ou faire une demande."
                    );
                  } else {
                    setLeadError("");
                  }

                  setShowSuggestions(true);
                }}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                className={`
    mt-2
    w-full
    h-11
    rounded-md
    bg-white
    px-3
    text-sm
    outline-none
    transition-all
    border-2
    ${
      leadError
        ? "border-red-400 focus:border-red-500"
        : "border-slate-300 focus:border-emerald-400"
    }
  `}
                placeholder="Sélectionner un client, un lead ou un contact annuaire..."
              />
            </div>

            {/* Suggestions (style Command / Popover) */}
            {showSuggestions && filteredSuggestions.length > 0 && (
              <ul className="mt-1 max-h-60 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg">
                {filteredSuggestions.map((item) => {
                  const displayName =
                    item.type === "annuaire"
                      ? `${item.nom || ""} ${item.prenoms || ""}`.trim()
                      : item.type === "prospect"
                      ? item.prenom
                        ? `${item.prenom} ${item.nom}`
                        : item.nom
                      : item.nom;
                  const badgeStyle =
                    item.type === "client"
                      ? "bg-emerald-100 text-emerald-700"
                      : item.type === "annuaire"
                      ? "bg-blue-100 text-blue-700"
                      : "bg-yellow-100 text-yellow-800";
                  const badgeLabel =
                    item.type === "client"
                      ? "Client"
                      : item.type === "annuaire"
                      ? "Annuaire"
                      : "Lead";
                  return (
                    <li
                      key={`${item.type}-${item.id}`}
                      onMouseDown={() => handleSelectItem(item)}
                      className="
          cursor-pointer
          px-3
          py-2
          text-sm
          text-slate-700
          hover:bg-slate-100
          transition-colors
          border-b last:border-b-0
          flex items-center justify-between gap-2
        "
                    >
                      <span className="truncate">{displayName}</span>
                      <span
                        className={`text-[10px] font-semibold px-2 py-0.5 rounded-full flex-shrink-0 ${badgeStyle}`}
                      >
                        {badgeLabel}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">
              Email Client / lead
            </label>
            <input
              className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.emailLead
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              name="emailLead"
              type="text"
              value={formData.emailLead}
              onChange={handleChange}
              placeholder="Raison sociale..."
            />
          </div>
          <div className="grid grid-cols-2 gap-4 mt-3">
            {/* Forme sociale */}
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Forme Sociale <span className="text-red-500">*</span>
              </label>

              <select
                name="formeSociale"
                value={formData.formeSociale}
                onChange={handleChange}
                className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.formeSociale
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "E.I",
                  "E.I.R.L",
                  "EARL",
                  "EURL",
                  "SARL",
                  "SPFPL (SARL)",
                  "SASU",
                  "SAS",
                  "SPFPL (SAS)",
                  "SCI",
                  "SCCV",
                  "LMNP",
                  "GFA",
                  "SC",
                  "SCP",
                  "SEL",
                  "N/A",
                ].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {/* Capital social */}
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Capital social <span className="text-red-500">*</span>
              </label>

              <input
                name="capital"
                type="text"
                value={formData.capital}
                onChange={handleChange}
                placeholder="Ex : 10 000 €"
                className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.capital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mt-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Régime Fiscal <span className="text-red-500">*</span>
              </label>
              <select
                name="regimeFiscal"
                type="text"
                value={formData.regimeFiscal}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.regimeFiscal
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "IS RS",
                  "IS RN",
                  "IR BIC Micro",
                  "IR BIC RS",
                  "IR BIC RN",
                  "IR BNC micro",
                  "IR BNC réel",
                  "IR RF",
                  "IR LMNP",
                ].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Régime TVA <span className="text-red-500">*</span>
              </label>
              <select
                name="regimeTVA"
                type="text"
                value={formData.regimeTVA}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.regimeTVA
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              >
                <option value="">Sélectionner...</option>
                {["N/A", "Franchise", "RSI", "RN", "Mini réel"].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">
              Dénomination sociale
            </label>
            <input
              className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.nomSociete
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              name="nomSociete"
              type="text"
              value={formData.nomSociete}
              onChange={handleChange}
              placeholder="Raison sociale..."
            />
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">
              Nom commercial (optionnel)
            </label>
            <input
              className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.nomCommercial
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              name="nomCommercial"
              type="text"
              value={formData.nomCommercial}
              onChange={handleChange}
              placeholder="Raison sociale..."
            />
          </div>
        </div>

        {leadError && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
            {leadError}
          </div>
        )}
        <div className="grid grid-cols-2 gap-4 mt-6">
          <div className="relative mb-4">
            {/* Label */}
            <label className="text-sm font-medium text-slate-700">
              Secteur d’activité
            </label>

            {/* Input + bouton */}
            <div className="flex gap-2 mt-2">
              <input
                type="text"
                placeholder="Ajouter..."
                value={selectedSecteur}
                onChange={(e) => setSelectedSecteur(e.target.value)}
                className="
        h-10
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        border-slate-300
        outline-none
        transition-all
        focus:border-emerald-400
      "
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addSecteur();
                  }
                }}
              />

              <button
                type="button"
                onClick={addSecteur}
                className="
        h-10
        px-4
        rounded-md
        bg-[#9B1B5D]
        text-white
        text-sm
        font-medium
        hover:bg-[#7A1548]
        transition-colors
        flex
        items-center
        justify-center
      "
              >
                Ajouter
              </button>
            </div>

            {/* Suggestions */}
            {selectedSecteur && (
              <ul
                className="
      absolute
      left-0
      top-[72px]
      w-full
      max-h-40
      overflow-y-auto
      rounded-md
      border
      border-slate-200
      bg-white
      shadow-lg
      z-10
    "
              >
                {secteursRef
                  .filter((s) =>
                    s.secteurActivite
                      .toLowerCase()
                      .includes(selectedSecteur.toLowerCase())
                  )
                  .map((s, idx) => (
                    <li
                      key={idx}
                      onClick={() => setSelectedSecteur(s.secteurActivite)}
                      className="
              cursor-pointer
              px-3
              py-2
              text-sm
              text-slate-700
              hover:bg-slate-100
              transition-colors
              border-b
              last:border-b-0
            "
                    >
                      {s.secteurActivite}
                    </li>
                  ))}
              </ul>
            )}
          </div>

          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Banque
            </label>
            <select
              name="banque"
              value={formData.banque}
              onChange={handleChange}
              className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.banque
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
            >
              <option value="">-- Sélectionner --</option>
              {[
                "Crédit Agricole",
                "BNP Paribas",
                "Société Générale",
                "LCL",
                "Caisse d'Épargne",
                "Banque Populaire",
                "CIC",
                "Crédit Mutuel",
                "La Banque Postale",
                "HSBC",
                "Boursorama",
                "Fortuneo",
                "Hello bank!",
                "N26",
                "Revolut",
                "Qonto",
                "Shine",
                "Autre",
              ].map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
        {formData.secteurActivite.split(" / ").filter((s) => s.trim() !== "")
          .length > 0 && (
          <div className="mt-2">
            {/* Titre */}
            <h4 className="text-sm font-semibold text-slate-700 ">
              Secteurs d’activité ajoutés
            </h4>

            {/* Table container */}
            <div className="overflow-hidden rounded-lg bg-white ">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium">Secteur</th>
                    <th className="px-4 py-2 text-left font-medium">
                      Commentaire
                    </th>
                    <th className="px-4 py-2 text-right font-medium">Action</th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-200">
                  {formData.secteurActivite
                    .split(" / ")
                    .filter((s) => s.trim() !== "")
                    .map((secteur, idx) => (
                      <tr
                        key={idx}
                        className="hover:bg-slate-50 transition-colors"
                      >
                        <td className="px-4 py-2 text-slate-700">{secteur}</td>

                        <td className="px-4 py-2 text-slate-500">
                          {formData.secteurActiviteCommentaire.split(" / ")[
                            idx
                          ] || "—"}
                        </td>

                        <td className="px-4 py-2 text-right">
                          <button
                            type="button"
                            onClick={() => removeSecteur(secteur)}
                            className="
                      text-xs
                      font-medium
                      text-red-500
                      hover:text-red-600
                      transition-colors
                    "
                          >
                            Retirer
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 mt-4">
          <label className="text-sm font-semibold flex items-center gap-2 mb-3">
            <MapPin className="w-4 h-4 text-slate-500" />
            Siège social
          </label>
          <div className="grid grid-cols-[1fr_auto] gap-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Siège Social
              </label>
              <input
                name="siegeSocial"
                type="text"
                value={formData.siegeSocial}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.siegeSocial
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Type de siège social
              </label>

              <select
                name="typeSocial"
                value={formData.typeSocial}
                onChange={handleChange}
                className={`
      mt-2
      h-11
      w-full
      rounded-md
      bg-white
      px-3
      text-sm
      border-2
      outline-none
      transition-all
      ${
        formData.typeSocial
          ? "border-emerald-300 focus:border-emerald-400"
          : "border-slate-300 focus:border-slate-400"
      }
    `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "Propriétaire",
                  "Locataire",
                  "Hébergé à titre gratuit",
                  "Domiciliation",
                  "Autre",
                ].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Complément d'adresse
              </label>
              <input
                name="adresse_complement"
                type="text"
                value={formData.adresse_complement}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.adresse_complement
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Code Postal
              </label>
              <input
                name="codePostal"
                type="text"
                value={formData.codePostal}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.codePostal
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Ville
              </label>
              <input
                name="ville"
                type="text"
                value={formData.ville}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.ville
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              />
            </div>
          </div>
        </div>
        <div className="mt-4 bg-slate-50 rounded-xl p-4 border border-slate-200">
          {/* Header */}
          <div className="flex items-center justify-between mb-3">
            <label className="text-sm font-semibold flex items-center gap-2">
              <Users className="w-4 h-4 text-slate-500" />
              Associés
            </label>
            <button
              type="button"
              onClick={addAssocie}
              className="
        h-8
        px-3
        rounded-md
        bg-[#9B1B5D]
        text-white
        text-xs
        font-medium
        hover:bg-[#7A1548]
        transition-colors
      "
            >
              + Ajouter
            </button>
          </div>

          {/* Header grid */}
          <div className="grid [grid-template-columns:2fr_2fr_2fr_80px_60px_40px] gap-2 mb-2 text-xs font-medium text-slate-600">
            <div>Nom</div>
            <div>Email</div>
            <div>Téléphone</div>
            <div className="text-center">Part %</div>
            <div className="text-center">Dirigeant</div>
            <div></div>
          </div>

          {/* Rows */}
          {associes.map((associe, index) => (
            <div
              key={index}
              className="grid [grid-template-columns:2fr_2fr_2fr_80px_60px_40px] gap-2 mb-2 items-center"
            >
              {/* Nom */}
              <input
                name="nomAssocie"
                value={associe.nomAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Nom associé"
                className="
          h-9
          rounded-md
          bg-white
          px-3
          text-sm
          border
          border-slate-300
          outline-none
          focus:border-emerald-400
        "
              />
              <input
                name="emailAssocie"
                value={associe.emailAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Email associé"
                className="
          h-9
          rounded-md
          bg-white
          px-3
          text-sm
          border
          border-slate-300
          outline-none
          focus:border-emerald-400
        "
              />
              <input
                name="telephoneAssocie"
                value={associe.telephoneAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Téléphone associé"
                className="
          h-9
          rounded-md
          bg-white
          px-3
          text-sm
          border
          border-slate-300
          outline-none
          focus:border-emerald-400
        "
              />
              {/* Pourcentage */}
              <input
                name="pourcentage"
                type="number"
                value={associe.pourcentage}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="%"
                className="
          h-9
          rounded-md
          bg-white
          px-3
          text-sm
          border
          border-slate-300
          outline-none
          focus:border-emerald-400
        "
              />
              {/* Dirigeant */}
              <div className="flex justify-center">
                <input
                  name="dirigeant"
                  type="checkbox"
                  checked={associe.dirigeant}
                  onChange={(e) => handleAssocieChange(index, e)}
                  className="h-4 w-4 accent-[#9B1B5D]"
                />
              </div>
              {/* Actions */}
              <button
                type="button"
                onClick={() => removeAssocie(index)}
                className="
          h-8
          w-8
          flex
          items-center
          justify-center
          rounded-md
          hover:bg-red-50
          text-red-600
          text-xs
          transition-colors
        "
              >
                <Trash2 className="w-3 h-3 text-red-600" />
              </button>
            </div>
          ))}
        </div>
        <br />
        <div className="mt-0 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <div className="w-full flex items-center justify-between p-3 hover:bg-slate-100 transition-colors rounded-t-xl">
            {/* Titre */}
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Clauses relatives aux associés
            </span>

            {/* Oui / Non + Chevron */}
            <div className="flex items-center gap-4">
              {/* Oui / Non */}
              <div
                className="flex items-center gap-2 text-sm text-slate-600"
                onClick={(e) => e.stopPropagation()} // ⚡ stop la propagation pour pas fermer le collapsible
              >
                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="acteAnterieur"
                    value="true"
                    checked={formData.acteAnterieur === true}
                    onChange={() =>
                      handleChange({
                        target: { name: "acteAnterieur", value: true },
                      })
                    }
                    className="h-4 w-4 accent-[#9B1B5D]"
                  />
                  Oui
                </label>

                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="acteAnterieur"
                    value="false"
                    checked={formData.acteAnterieur === false}
                    onChange={() =>
                      handleChange({
                        target: { name: "acteAnterieur", value: false },
                      })
                    }
                    className="h-4 w-4 accent-[#9B1B5D]"
                  />
                  Non
                </label>
              </div>

              {/* Chevron */}
              <button
                type="button"
                onClick={() => setClausesAssociesOpen(!clausesAssociesOpen)}
                className="flex items-center justify-center text-slate-500"
              >
                {clausesAssociesOpen ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>
            </div>
          </div>

          {/* Contenu */}
          {clausesAssociesOpen && (
            <div className="p-4 space-y-3">
              {/* Checkboxes */}
              <div className="grid grid-cols-2 gap-3">
                {[
                  { name: "clauseAgreement", label: "Clause d'agrément" },
                  { name: "clauseExclusion", label: "Clause d'exclusion" },
                  {
                    name: "clauseInalienabilite",
                    label: "Clause d'inaliénabilité",
                  },
                  { name: "clausePreemption", label: "Clause de préemption" },
                  { name: "clauseSortie", label: "Clause Sortie" },
                  { name: "autresClauses", label: "Autres" },
                ].map(({ name, label }) => (
                  <label
                    key={name}
                    className="flex items-center gap-2 bg-white p-2 rounded-lg border border-slate-200 hover:border-[#9B1B5D]/30 transition-colors cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      name={name}
                      checked={formData[name]}
                      onChange={handleChange}
                      className="h-4 w-4 accent-[#9B1B5D]"
                    />
                    {label}
                  </label>
                ))}
              </div>

              {/* Commentaire */}
              <div>
                <textarea
                  name="commentaire"
                  rows={4}
                  value={formData.commentaire}
                  onChange={handleChange}
                  placeholder="Précisions..."
                  className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
                />
              </div>
            </div>
          )}
        </div>

        <br />
        <div className="mt-0 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <button
            type="button"
            onClick={() => setClausesAssociesOpen2(!clausesAssociesOpen2)}
            className="w-full p-3 flex items-center justify-between hover:bg-slate-100 transition-colors rounded-t-xl"
          >
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Clauses relatives à la gouvernance
            </span>

            <span className="text-slate-500">
              {clausesAssociesOpen2 ? (
                <ChevronUp className="w-4 h-4 text-slate-500" />
              ) : (
                <ChevronDown className="w-4 h-4 text-slate-500" />
              )}
            </span>
          </button>

          {/* Contenu */}
          {clausesAssociesOpen2 && (
            <div className="p-4 space-y-3">
              {/* Checkboxes */}
              <div className="grid grid-cols-2 gap-3">
                {[
                  {
                    name: "existenceAction",
                    label: "Existence d'action de préférence",
                  },
                  { name: "quorum", label: "Quorum ou majorité renforcée" },
                  {
                    name: "limitation",
                    label: "Limitation des pouvoirs du dirigeant",
                  },
                  { name: "autresClauses2", label: "Autres" },
                ].map(({ name, label }) => (
                  <label
                    key={name}
                    className="flex items-center gap-2 bg-white p-2 rounded-lg border border-slate-200 hover:border-[#9B1B5D]/30 transition-colors cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      name={name}
                      checked={formData[name]}
                      onChange={handleChange}
                      className="h-4 w-4 accent-[#9B1B5D]"
                    />
                    {label}
                  </label>
                ))}
              </div>

              {/* Commentaire */}
              <div>
                <label className="text-sm font-medium text-slate-700 mb-1 block">
                  Commentaire :
                </label>
                <textarea
                  name="commentaire2"
                  rows={4}
                  value={formData.commentaire2}
                  onChange={handleChange}
                  placeholder="Précisions..."
                  className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
                />
              </div>
            </div>
          )}
        </div>

        <div>
          <label className="text-sm font-semibold text-slate-700 flex items-center gap-1 mt-8">
            Date de clôture
          </label>
          <input
            name="dateCloture"
            type="date"
            value={formData.dateCloture}
            onChange={handleChange}
            className={`
              mt-2
              h-11
              w-full
              rounded-md
              bg-white
              px-3
              text-sm
              border-2
              outline-none
              transition-all
              ${
                formData.dateCloture
                  ? "border-emerald-300 focus:border-emerald-400"
                  : "border-slate-300 focus:border-slate-400"
              }
            `}
          />
        </div>
        {/* <div style={{ display: "flex", flexDirection: "row", gap: "10%" }}>
          <label>Commentaire :</label>
          <textarea
            style={{ width: "70%" }}
            name="commentaire3"
            type="text"
            value={formData.commentaire3}
            onChange={handleChange}
            rows={8}
          />
        </div>{" "} */}
        {/* 
        <div style={{ display: "flex", flexDirection: "row", gap: "10%" }}>
          <label>Commentaire Activité :</label>
          <textarea
            style={{ width: "70%" }}
            name="activite"
            type="text"
            value={formData.activite}
            onChange={handleChange}
            rows={8}
          />
        </div>{" "} */}
        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.dueDate
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.priority
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.status
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.coefficient
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
        </div>
        <div className="mt-6 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <button
            type="button"
            onClick={() => setChaqueAssocieDocument(!ChaqueAssocieDocument)}
            className="w-full p-3 flex items-center justify-between hover:bg-slate-100 transition-colors rounded-t-xl"
          >
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Documents à obtenir pour chaque associé
            </span>

            <span className="text-slate-500">
              {ChaqueAssocieDocument ? (
                <ChevronUp className="w-4 h-4 text-slate-500" />
              ) : (
                <ChevronDown className="w-4 h-4 text-slate-500" />
              )}
            </span>
          </button>

          {/* Contenu */}
          {ChaqueAssocieDocument && (
            <div className="p-4 space-y-4">
              {/* Pièces générales */}
              <div>
                <p className="font-medium text-slate-700 mb-2">Cas général :</p>
                <div className="space-y-2 ml-4">
                  {[
                    { label: "Pièce d’identité", name: "pieceId" },
                    { label: "Livret de famille", name: "livretFamille" },
                    {
                      label: "Carte de sécurité sociale / attestation",
                      name: "carteSecurite",
                    },
                    {
                      label: "Justificatif d’adresse personnelle",
                      name: "adressePerso",
                    },
                  ].map(({ label, name }) => (
                    <div key={name} className="flex items-center gap-3">
                      <span className="text-sm text-slate-700">{label}</span>
                      <input
                        type="file"
                        name={name}
                        onChange={handleFileChange}
                        className="text-sm text-slate-600"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Pièces selon situation */}
              <div className="ml-4 space-y-2">
                {/* Propriétaire */}
                <p className="font-medium text-slate-700">Si propriétaire :</p>
                <div className="flex items-center gap-3 ml-4">
                  <span className="text-sm text-slate-700">
                    Dernier avis d’imposition aux taxes foncières
                  </span>
                  <input
                    type="file"
                    name="avisImposition"
                    onChange={handleFileChange}
                    className="text-sm text-slate-600"
                  />
                </div>

                {/* Locataire */}
                <p className="font-medium text-slate-700 mt-2">
                  Si locataire :
                </p>
                <div className="flex items-center gap-3 ml-4">
                  <span className="text-sm text-slate-700">
                    Justificatif d’adresse supérieur inférieur 3 mois (facture
                    d’eau, électricité, internet fixe)
                  </span>
                  <input
                    type="file"
                    name="adressse"
                    onChange={handleFileChange}
                    className="text-sm text-slate-600"
                  />
                </div>

                {/* Hébergé */}
                <p className="font-medium text-slate-700 mt-2">Si hébergé :</p>
                <div className="space-y-2 ml-4">
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-slate-700 w-3/4">
                      Dernier avis d’imposition ou justificatif d’adresse
                      inférieur à 3 mois
                    </span>
                    <input
                      type="file"
                      name="dernierAvisImposition"
                      onChange={handleFileChange}
                      className="text-sm text-slate-600"
                    />
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-slate-700 w-3/4">
                      Pièce d’identité de l’hébergeur
                    </span>
                    <input
                      type="file"
                      name="pieceIdHebergeur"
                      onChange={handleFileChange}
                      className="text-sm text-slate-600"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Collaborateurs à notifier */}
        <div className="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <label className="text-sm font-semibold flex items-center gap-2 text-slate-700 mb-3">
            <Users className="w-4 h-4 text-slate-500" />
            Collaborateurs à notifier par email
          </label>
          <div className="relative">
            <input
              type="text"
              value={searchUser}
              onChange={handleSearchUser}
              placeholder="Rechercher un collaborateur…"
              autoComplete="off"
              className="w-full h-10 rounded-md bg-white px-3 text-sm border-2 border-slate-300 focus:border-emerald-400 outline-none transition-all"
            />
            {userSuggestions.length > 0 && (
              <ul className="absolute left-0 top-full mt-1 w-full max-h-48 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg z-20">
                {userSuggestions.map((user) => (
                  <li
                    key={user.id}
                    onClick={() => selectUser(user)}
                    className="cursor-pointer px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors border-b last:border-b-0"
                  >
                    {user.name} {user.lastName}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {notifiedUserIds.length === 0 ? (
              <p className="text-sm text-slate-400 italic">
                Aucun collaborateur sélectionné.
              </p>
            ) : (
              notifiedUserIds.map((id) => {
                const user = allUsers.find((u) => u.id === id);
                return (
                  <div
                    key={id}
                    className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 px-3 py-1.5 rounded-full text-sm"
                  >
                    <span>
                      {user?.name || "?"} {user?.lastName || ""}
                    </span>
                    <button
                      type="button"
                      onClick={() => removeUser(id)}
                      className="text-emerald-600 hover:text-red-500 font-medium transition-colors"
                    >
                      ✕
                    </button>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <br />
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="envoyerMail"
            checked={envoyerMail}
            onChange={(e) => setEnvoyerMail(e.target.checked)}
            className="h-4 w-4 accent-[#9B1B5D] rounded"
          />
          <label
            htmlFor="envoyerMail"
            className="text-sm text-slate-700 cursor-pointer"
          >
            Envoyer le mail d'information
          </label>
        </div>
        </div>
        <div className="shrink-0 bg-white border-t px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onCancel}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`
              w-1/2
              h-11
              bg-[#9B1B5D]
              hover:bg-[#7A1548]
              text-white
              text-base
              font-medium
              rounded-md
              shadow-lg shadow-[#9B1B5D]/20
              transition-colors
              flex items-center justify-center
              gap-2
            `}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Création en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Créer la mission
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreationSct;
